import { SUBMOTIVE1_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useSubmotive1ListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${SUBMOTIVE1_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
